module.exports = __webpack_public_path__ + "static/principlespage-daad42ce0238f5fe98e63dd8656731c0.png";